export const fetchApi = (method, url) => {
  return fetch(url, {
    method: method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      if (!response.ok) return response;
      return response
        .text()
        .then((text) => {
          try {
            const data = JSON.parse(text);
            return {
              data,
              ok: response.ok,
            };
          } catch (err) {
            return response;
          }
        })
        .catch((err) => console.warn("Fetch error: ", err));
    })
    .catch((err) => console.warn("Fetch error: ", err));
};